import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { DatePicker } from "@/components/app/DatePicker";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus } from "@phosphor-icons/react";

const RISK_OPTIONS = (
  <SelectContent>
    <SelectItem value="faible">Faible</SelectItem>
    <SelectItem value="moyen">Moyen</SelectItem>
    <SelectItem value="eleve">Élevé</SelectItem>
  </SelectContent>
);

function Ck({ form, setForm, k, label }) {
  return (
    <label className="flex items-center gap-2 text-sm">
      <Checkbox checked={form[k]} onCheckedChange={(v) => setForm({ ...form, [k]: !!v })} data-testid={`lcbft-${k}`} />
      <span>{label}</span>
    </label>
  );
}

/** Formulaire d'évaluation LCB-FT (dialog). */
export function LcbFtFormDialog({ open, setOpen, form, setForm, clients, onSubmit, submitting }) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button data-testid="new-lcbft-btn" className="bg-[#2E3192] hover:bg-[#1E2066]"><Plus size={16} className="mr-1" /> Nouvelle évaluation</Button>
      </DialogTrigger>
      <DialogContent className="max-w-3xl">
        <DialogHeader><DialogTitle className="font-serif-display text-2xl">Évaluation LCB-FT</DialogTitle></DialogHeader>
        <form onSubmit={onSubmit} className="space-y-5">
          <div>
            <Label>Client *</Label>
            <Select value={form.client_id} onValueChange={(v) => setForm({ ...form, client_id: v })}>
              <SelectTrigger data-testid="lcbft-client"><SelectValue placeholder="Sélectionner un client" /></SelectTrigger>
              <SelectContent>{clients.map((c) => (<SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>))}</SelectContent>
            </Select>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 border border-zinc-200 rounded p-4">
            <div className="md:col-span-2 text-[10px] uppercase tracking-[0.22em] text-zinc-500">Identification du client</div>
            <Ck form={form} setForm={setForm} k="beneficial_owners_identified" label="Bénéficiaires effectifs identifiés" />
            <Ck form={form} setForm={setForm} k="id_documents_collected" label="Pièces d'identité collectées et vérifiées" />
            <Ck form={form} setForm={setForm} k="pep_status" label="Personne politiquement exposée (PPE)" />
            <Ck form={form} setForm={setForm} k="sanctions_check" label="Contrôle listes de sanctions / gel des avoirs" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 border border-zinc-200 rounded p-4">
            <div className="md:col-span-2 text-[10px] uppercase tracking-[0.22em] text-zinc-500">Activité & risques</div>
            <div>
              <Label>Risque sectoriel</Label>
              <Select value={form.activity_sector_risk} onValueChange={(v) => setForm({ ...form, activity_sector_risk: v })}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                {RISK_OPTIONS}
              </Select>
            </div>
            <div>
              <Label>Risque géographique</Label>
              <Select value={form.geographic_risk} onValueChange={(v) => setForm({ ...form, geographic_risk: v })}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                {RISK_OPTIONS}
              </Select>
            </div>
            <Ck form={form} setForm={setForm} k="cash_intensive" label="Activité à forte manipulation d'espèces" />
            <Ck form={form} setForm={setForm} k="complex_structure" label="Structure juridique complexe" />
          </div>

          <div><Label>Mesures de vigilance déjà prises</Label><Textarea rows={2} value={form.vigilance_measures} onChange={(e) => setForm({ ...form, vigilance_measures: e.target.value })} /></div>
          <div><Label>Prochaine revue prévue</Label><DatePicker value={form.next_review_date} onChange={(v) => setForm({ ...form, next_review_date: v })} testid="lcbft-next-review" /></div>

          <div className="flex justify-end">
            <Button type="submit" disabled={!form.client_id || submitting} className="bg-[#2E3192] hover:bg-[#1E2066]" data-testid="lcbft-submit">
              {submitting ? "Analyse IA en cours…" : "Enregistrer & analyser"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
